import { Dispatch } from 'react';
import { UserData } from './common.type';

export type AppState = {
  currentUser: UserData;
  authenticated: boolean;
  authToken: string | null;
  currentRole?: string;
  refreshToken?: string | null;
  bookName?: string | null;
};

export enum AppActionType {
  setCurrentUser = 'SET_CURRENT_USER',
  setAuthenticated = 'SET_AUTHENTICATED',
  setAuthToken = 'SET_TOKEN',
  setCurrentRole = 'SET_CURRENT_ROLE',
  setRefreshToken = 'SET_REFRESH_TOKEN',
  logout = 'LOGOUT',
  setBookName = 'SET_BOOK_NAME',
}

export type AppAction =
  | { type: AppActionType.setCurrentUser; data: UserData }
  | { type: AppActionType.setAuthenticated; data: boolean }
  | { type: AppActionType.setAuthToken; data: string | null }
  | { type: AppActionType.setRefreshToken; data: string | null }
  | { type: AppActionType.setCurrentRole; data: string }
  | { type: AppActionType.setBookName; data: string | null }
  | { type: AppActionType.logout };

export type AppContextType = {
  state: AppState;
  dispatch: Dispatch<AppAction>;
  getToken: () => string | null;
  isAuthenticated: () => boolean;
  getRefreshToken: () => string | null;
  initializeAuth: (
    authToken: string | null,
    userData: UserData | null,
    refreshToken?: string | null,
  ) => void;
  getCurrentUser: () => void;
};
